const withDefaults = <T extends object>(o: T, defaults: Required<T>): Required<T> => ({
  ...defaults,
  ...o
});
export default withDefaults;
